import { Box, Skeleton, Stack, Paper } from '@mui/material';

const MessageSkeleton = ({ align = 'right' }: { align?: 'right' | 'left' }) => {
  const isRight = align === 'right';
  return (
    <Stack direction={isRight ? 'row' : 'row-reverse'} width="70%" marginLeft={isRight ? 'auto' : 0}>
      <Box sx={{ display: 'grid', width: '100%', gap: 1 }}>
        <Box
          sx={{ display: 'flex', justifyContent: isRight ? 'flex-end' : 'flex-start', alignItems: 'center', gap: 1 }}
        >
          <Skeleton variant="text" width={120} height={24} />
          <Skeleton variant="text" width={100} height={24} />
        </Box>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            justifySelf: isRight ? 'flex-end' : 'flex-start',
            borderRadius: 1.5,
            width: '100%',
            maxWidth: '600px',
            ml: isRight ? -3.5 : 0,
          }}
        >
          <Skeleton variant="text" width="90%" height={20} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="75%" height={20} />
        </Paper>
        <Box sx={{ display: 'flex', width: '100%', justifyContent: isRight ? 'flex-end' : 'flex-start', mt: 0.5 }}>
          <Skeleton variant="text" width={40} height={20} />
        </Box>
      </Box>
      <Box sx={{ p: 2, pt: 0.3 }}>
        <Skeleton variant="circular" width={28} height={28} />
      </Box>
    </Stack>
  );
};

const DateHeaderSkeleton = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
    <Skeleton variant="rounded" width={100} height={28} sx={{ borderRadius: '16px' }} />
  </Box>
);

export const LoadingState = () => (
  <Stack
    sx={{
      height: 'calc(100% - 236px)',
      borderRadius: '16px',
      margin: 3,
      padding: 2,
      gap: 3,
      border: (theme) => `1px solid ${theme.palette.divider}`,
      backgroundColor: (theme) => theme.palette.paper.dark,
    }}
  >
    <DateHeaderSkeleton />
    <MessageSkeleton />
    <MessageSkeleton />
    <DateHeaderSkeleton />
    <MessageSkeleton align="left" />
    <MessageSkeleton align="left" />
  </Stack>
);
